import script from "./LessonLibraryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonLibraryPage.vue?vue&type=script&setup=true&lang=js"

import "./LessonLibraryPage.vue?vue&type=style&index=0&id=433db174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433db174"]])

export default __exports__